<span class="result-token-payout-summary" [ngClass]="{ 'acca-boost': isAccaBoost() }" [innerHTML]="tokenPayoutSummary().summary"></span>
